import moment from "moment";

export const Message = (message, user) => {
    return {
        ...message,
        user,
    };
}

const User = (data) => {
    return {
        id: data.id,
        username: data.username,
        profile: {
            display_name: data.profile.display_name,
            profile_picture_url: data.profile?.profile_picture_url,
        },
    };
};

const uniqueMessages = (list) => {
    let messages = Object.values(list);

    messages.sort((a, b) => {
        return moment(a.timestamp).format('YYYYMMDD HH:mm:ss') > moment(b.timestamp).format('YYYYMMDD HH:mm:ss') ? 1 : -1;
    });

    return messages;
};

export const Conversation = (data, rootState) => {
    const isOperator = rootState.isOperator;
    let currentUser = rootState.chat.currentChatUser;

    if (!currentUser) {
        currentUser = rootState.chat.internalUsers.find(
            e => e.id === data.first_user_id || e.id === data.second_user_id
        );
    }

    const conversationWithUserId = data.first_user_id !== currentUser.id
        ? data.first_user_id
        : data.second_user_id;

    let user = rootState.chat.contacts.find(e => e.id === conversationWithUserId);

    const messages = uniqueMessages(
        (data.messages || []).map(e => Message(e, e.user_id === currentUser.id ? currentUser : user))
    );

    let Item = {
        id: data.id ? data.id : 'new',
        new: !data.id,
        toBeInitiated: (isOperator || data.first_user_id === currentUser.id) && !messages.length,
        messages: messages ? messages : [],
        user: User(user),

        createMessage: (message) => {
            if (!message.timestamp) {
                message.timestamp = new Date();
            }

            return Message(message,
                message.user_id === Item.user.id ? Item.user : User(currentUser)
            );
        },

        reload: () => {
            //
        },
    };

    return Item;
}
